module.exports = __webpack_public_path__ + "static/media/sg.ad89ba7f.svg";